package fr.frux.shared.domain.model

/**
 * Filtres de la carte, evalues cote serveur : filtrer seulement la page deja chargee rendrait le
 * total et la pagination faux. La partie recoltee est l'axe principal de decouverte ; la forme de
 * la plante est un axe distinct et secondaire (ADR 0006).
 */
data class MapFilter(
    val part: HarvestPart? = null,
    val form: PlantForm? = null,
    val inSeason: Boolean = false,
    /**
     * Masque les arbres qui demandent une vérification (#265). Formulé en soustraction, jamais en
     * « voir seulement les douteux » : l'inverse construirait une carte du danger, ce que l'ADR
     * 0015 refuse. Appliqué côté client (`certainty` et `disputed` sont déjà dans le lot reçu),
     * contrairement aux trois autres axes qui partent en paramètres de requête.
     */
    val hideNeedsCheck: Boolean = false,
    /**
     * Restreint aux especes agregees sous ce `rollup_id` (« tous les pommiers », ADR 0006). Jamais
     * pose par les puces de filtre : la selection d'espece reste un filtre client sur le lot recu.
     * Seul l'elargissement « Voir les plus proches » le transmet, pour que le serveur rende les
     * arbres de l'espece les plus proches et pas les N plus proches toutes especes confondues.
     */
    val rollupId: Long? = null,
) {
    val isActive: Boolean get() = part != null || form != null || inSeason || hideNeedsCheck || rollupId != null

    /**
     * Part du filtre qui change la requête. [hideNeedsCheck] n'en fait pas partie : il retire des
     * arbres du lot déjà reçu, le serveur renverrait le même. Deux filtres qui ne diffèrent que
     * par lui n'ont donc aucune raison de déclencher un aller-retour réseau.
     */
    val query: MapFilter get() = copy(hideNeedsCheck = false)

    companion object {
        val None = MapFilter()
    }
}
